import { makeMutation } from '../types'

type Output = boolean;

export const logout = makeMutation<Output>('mutation{logout}')
